module.exports = {"schedule":{"title":"Programma","now_playing":"Speelt nu","empty":{"title":"Niets gevonden","detail":"Er zijn geen items gevonden"}}}